import { render, staticRenderFns } from "./ConfirmBuyProduct.vue?vue&type=template&id=4533408c&scoped=true&"
import script from "./ConfirmBuyProduct.vue?vue&type=script&lang=js&"
export * from "./ConfirmBuyProduct.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmBuyProduct.vue?vue&type=style&index=0&id=4533408c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4533408c",
  null
  
)

export default component.exports